import { useNavigate, useLocation } from 'react-router-dom';
import { Inbox, AlertCircle, Target, LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import logo from '@/assets/logo.png';

interface NavItem {
  id: string;
  icon?: LucideIcon;
  label: string;
  path: string;
  isSentinel?: boolean;
}

const navItems: NavItem[] = [
  { id: 'inbox', icon: Inbox, label: 'Inbox', path: '/inbox' },
  { id: 'exceptions', icon: AlertCircle, label: 'Exceptions', path: '/exceptions' },
  { id: 'sentinel', label: 'Sentinel', path: '/sentinel', isSentinel: true },
  { id: 'runway', icon: Target, label: 'Runway', path: '/runway' },
];

export function MobileBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-card/95 backdrop-blur-xl border-t border-border/50 flex items-center justify-around z-50 pb-[env(safe-area-inset-bottom)] h-[calc(72px+env(safe-area-inset-bottom,0px))] shadow-premium">
      {navItems.map((item) => {
        const isActive = location.pathname === item.path;
        const Icon = item.icon;
        
        return (
          <button
            key={item.id}
            onClick={() => navigate(item.path)}
            className={cn(
              "flex flex-col items-center justify-center flex-1 h-full gap-1 transition-all duration-300",
              item.isSentinel && "relative -mt-4",
              isActive && !item.isSentinel && "text-primary",
              !isActive && !item.isSentinel && "text-muted-foreground hover:text-foreground"
            )}
          >
            {item.isSentinel ? (
              <div className={cn(
                "w-14 h-14 rounded-3xl flex items-center justify-center transition-all duration-300 shadow-glow",
                isActive 
                  ? "bg-gradient-primary scale-110" 
                  : "bg-gradient-to-br from-primary/80 to-accent/80 hover:scale-105"
              )}>
                <img 
                  src={logo} 
                  alt="Sentinel" 
                  className="w-7 h-7 brightness-0 invert" 
                />
              </div>
            ) : Icon ? (
              <div className={cn(
                "p-2 rounded-2xl transition-all duration-300",
                isActive && "bg-primary/10"
              )}>
                <Icon size={22} strokeWidth={isActive ? 2.5 : 2} />
              </div>
            ) : null}
            <span className={cn(
              "text-[10px] font-medium transition-all",
              item.isSentinel && "mt-1"
            )}>
              {item.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
